<template lang="pug">
  include ./../../../mixins
  div
    router-module()
    +b.pa--t_md.--b_md.SECTION
      +b.ug-container--variant_large
        +b.ma--b_md.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'initial'"
          :fs="'xl'"
          :color="'black'"
          :tag="'p'"
        ) BALANCE HISTORY
        +b.ug-row--apearance_spaced.--space_md
          +b.ug-cell.ug-cols--12.--7-lg.--8-xl.--9-mac
            +b.pa--t_1sm.--t_md-md.--r_1sm.--r_md-md.--l_1sm.--l_md-md.--b_1sm.bg--white
              +b.ug-row--apearance_spaced.--space_md
                +b.ug-cell.ug-cols--12
                  balance-history-table(
                    v-if="Object.keys(balanceItems).length"
                    :object-list="balanceItems"
                    @ordering="setOrderingHandler"
                  )
                  +b.text.pa--b_xs-md(
                    v-if="!Object.keys(balanceItems).length"
                  ) No results
          +b.ug-cell.ug-cols--12.--5-lg.--4-xl.--3-mac
            +b.withdraw--invoice
              +b.ma--b_md.TEXT-BEMTO(
                :cfg="'center'"
                :fw="'bold'"
                :lh="'initial'"
                :fs="'xl'"
                :color="'black'"
                :tag="'p'"
              ) BALANCE
              +b.ma--b_md.TEXT-BEMTO(
                :cfg="'center'"
                :fw="'bold'"
                :lh="'initial'"
                :fs="'6xl'"
                :color="'black'"
                :tag="'p'"
              ) {{ amount }} &#163
              +b.button--height_xl.ROUTER-LINK(
                :to="{ name: 'WithdrawCabinet' }"
              ) WITHDRAW
        +b.ug-cols--12
          +b.ma--t_md.PAGINATION-MODULE(
            :pagination="pagination"
            :extra="1"
            :need-add-btns="true"
            @update-limit="setPaginationLimitHandler"
            @input="pageСhangedHandler($event)"
          )
</template>

<script>
import {
  getDrawBalanceAPI,
  getBalanceHistoryAPI,
} from '@/js/services/cabinet'

export default {
  name: 'BalanceHistoryCabinet',
  created() {
    this.getDrawBalanceAPI()
    this.getBalanceHistoryAPI()
  },
  data() {
    return {
      /**
       * Components state.
       */
      formData: {
        ordering: null,
      },
      balanceItems: [],
      amount: null,
      pagination: {},
      paginationData: {},
    }
  },
  methods: {
    getDrawBalanceAPI() {
      return getDrawBalanceAPI.execute({})
        .then(response => {
          this.amount = response.data.item.balance
        })
    },
    getBalanceHistoryAPI(OPTIONS) {
      return getBalanceHistoryAPI.execute(OPTIONS)
        .then(response => response.json())
        .then(response => {
          this.balanceItems = response.data.items
          this.pagination = response.data.pagination
        })
    },
    async preperedBeforeAPI() {
      const OPTIONS = {
        ...this.formData,
        ...this.paginationData
      }
      await this.getBalanceHistoryAPI(
        OPTIONS
      )
    },
    async pageСhangedHandler(data) {
      this.paginationData = data
      await this.preperedBeforeAPI()
    },
    async setPaginationLimitHandler(value) {
      this.paginationData.limit = value
      this.paginationData.offset = 0
      await this.preperedBeforeAPI()
    },
    async setOrderingHandler(value) {
      this.formData.ordering = value
      await this.preperedBeforeAPI()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Pages/Cabinet/BalanceHistoryCabinet.vue